<template>
<div class="chapter">
<div class="inner_page">
<p class="copya" style="margin-top:2em;">Publisher: Amy Marson</p>
<p class="copya">Creative Director: Gailen Runge</p>
<p class="copya">Editor: Lynn Koolish</p>
<p class="copya">Technical Editors: Debbie Rodgers and Deanna Csomo McCool</p>
<p class="copya">Cover/Book Designer: April Mostek</p>
<p class="copya">Production Coordinator: Tim Manibusan</p>
<p class="copya">Production Editors: Alice Mace Nakanishi, Jessie Brotman, and Jennifer Warren</p>
<p class="copya">Illustrator: Freesia Pearson Blizard</p>
<p class="copya">Photo Assistant: Carly Jean Marin</p>
<p class="copya">Instructional photography by Diane Pedersen, unless otherwise noted</p>
<p class="copya">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?c8a94dda